<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Liquidación</div>
        <span class="grey--text text--lighten-2">Resumen de la liquidación agrupado por tipo de gasto</span>

        <div class='pt-2'>{{ liquidacionCargada }}</div>
      
      </div>
    </v-card-title>
  
    <v-data-table
      :headers="cabecera"
      :items="resumen"
      hide-actions
      class="elevation-1 pa-2"
      no-data-text="Sin datos"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left"><router-link :to="'/liquidaciones/'+ idLiquidacion + '/detalle/' + props.item.IDTIPO_GASTO_INGRESO">{{ props.item.DESC_TIPO_GASTO_INGRESO }}</router-link></td>
        <td class="text-xs-right">{{ props.item.TOTAL | moneda }}</td>
      </template>

    </v-data-table>
    
  </v-card>
  
 </template>

<style>
</style>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { LIQUIDACION_RESUMEN_REQUEST } from '../store/actions/liquidaciones';

  export default {
    name: 'BrwResumenLiquidacion',
    props: {
      'idLiquidacion': { type: Number, required: true }
    },
    data: function () {
      return {
        cabecera: [
          {
            text: 'Descripción',
            align: 'left',
            sortable: true,
            value: 'DESC_TIPO_GASTO_INGRESO'
          },
          {
            text: 'Importe',
            align: 'right',
            sortable: true,
            value: 'TOTAL'
          }
        ]
      }
    },
    created: function () {
      this.cargarResumenLiquidacion()
    },
    watch: {
      '$route': 'cargarResumenLiquidacion'
    },
    methods: {
      cargarResumenLiquidacion() {
        this.$store.dispatch(LIQUIDACION_RESUMEN_REQUEST, {
          idLiquidacion: this.idLiquidacion
        })
      }
    },
    filters: {
        moneda: function (value) {
            value = value.toLocaleString('es-ES', { style: 'currency', currency: 'EUR'})
            return value
        }
    },
    computed: {
      ...mapState({
        resumen: state => state.liquidaciones.resumen_liquidacion
      }),
      ...mapGetters([ 'liquidacionCargada' ])
    }
  }
</script>